var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.badge > 0)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.params.click(_vm.params.data)}}},[_c('v-badge',{attrs:{"bordered":"","color":"error","content":_vm.params.badge,"overlap":"","value":_vm.params.badge > 0}},[_c('v-icon',[_vm._v("mdi-bell")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }